class FeaturePermissionsHelper {
  static hasModule(user, module) {
    let modules = FeaturePermissionsHelper.getModules(user);
    // console.log('modules', modules);
    return modules.includes(module);
  }

  static getModules(user) {
    const featurePermissions = user?.featurePermissions;
    // console.log('featurePermissions', featurePermissions);
    const modules = {};
    for (const key in featurePermissions) {
      if (featurePermissions[key].modules) {
        try {
          let mods = JSON.parse(featurePermissions[key].modules);
          mods.forEach((mod) => {
            modules[mod] = true;
          });
        } catch (e) {}
      }
    }
    return Object.keys(modules);
  }

  static hasPermission(user, feature, permission) {
    return user?.featurePermissions?.[feature]?.permissions?.[permission] > 0;
  }
}

export default FeaturePermissionsHelper;
